import { FC } from 'react';

import { TypographyProps, Typography } from '@mui/material';
import { Icon, IconProps } from '@iconify/react';

export interface Props extends TypographyProps {
  icon: IconProps['icon'];
  iconSide?: 'left' | 'right';
  iconProps?: Omit<IconProps, 'icon'>;
}

/**
 * IconText
 */
const IconText: FC<Props> = ({ children, iconProps, icon, iconSide = 'left', ...props }) => {
  return (
    <Typography component="span" display="flex" alignItems="center" {...props}>
      {iconSide === 'left' && <Icon {...iconProps} icon={icon} />}
      &nbsp;
      {children}
      {iconSide === 'right' && <Icon {...iconProps} icon={icon} />}
    </Typography>
  );
};

export default IconText;
